import OneClickPurchase from "./OneClickPurchase";

export default OneClickPurchase;



// WEBPACK FOOTER //
// ./src/apps/payment/components/OneClickPurchase/index.js